import { BrandColors } from "../themeInterfaces";
import { sharedColors } from "../themesSharedValues";

const textPrimary = "var(--p-color-text-primary)";

export const stbColors: BrandColors = {
  // primary-old: "#BF0900",
  primary: textPrimary,
  primaryVariant: "#AA0600",
  // primaryPressed: "#910300",
  primaryPressed: textPrimary,
  background: "#ffffff",
  // greenBackground: "#F5F9F0",
  greenBackground: "var(--p-color-surface-1)",
  border: { color: "#191919", opacity: "16%" },
  selection: {
    main: "#5B462B",
    background: "#ffffff",
    selectionHover: "#8C6E46",
    unselected: "#DDDDDD",
  },
  alert: {
    info: {
      background: "var(--p-color-surface-info)",
      accent: "#2A8EAC",
    },
    success: {
      // background: "#E8F3E1",
      background: "var(--p-color-surface-1)",
      accent: "#4A966E",
    },
    warning: {
      background: "#FDF6CF",
      accent: "#C17B0B",
    },
    error: {
      background: "#FEE6DB",
      accent: "#E36A31",
    },
  },
  disabled: {
    main: "#757575",
    disabledVariant: "#cccccc",
    scrim: { color: "#191919", opacity: "60%" },
  },
  overlay: {
    overlayHoverDarken: { color: "#191919", opacity: "5%" },
    overlayHoverLighten: { color: "#ffffff", opacity: "15%" },
    overlayHoverPressed: { color: "#191919", opacity: "10%" },
  },
  illustration: {
    illustrationBrand: "#DA291C",
    illustrationPrimary: "#BF0900",
    // illustrationBase: "#191919",
    illustrationBase: textPrimary,
  },
  icon: {
    iconDetail: "#DA291C",
    // iconOutline: "#191919",
    iconOutline: textPrimary,
  },
  graph: {
    graph00: "#e6e6e6",
    graph06: "#0191A5",
  },
  captionBackground: { color: "#191919", opacity: "75%" },
  charts: {
    blue20: "#D2F5F9",
    blue30: "#7ACDDC",
    blue50: "#0191A5",
    blue70: "#003F4A",
    green10: "#E8F3E1",
    green30: "#C6E7C1",
    green50: "#5F956A",
    green70: "#2B412E",
    beige30: "#F5E4C7",
    beige60: "#C7AA7F",
    beige70: "#957851",
    beige90: "#4F3B22",
    brand: "#DA291C",
  },
  inactive: "var(--p-color-text-secondary)",
  ...sharedColors,
};
